import styled from "styled-components";

export default styled.p`
    color: ${props => props.theme.colors.font};
    padding: 0;
    margin-top: 0;
    margin-bottom: 1em;
`;